export default {
  init() {
  	var $spinner = $('.spinner-container');
    var $userContainer = $('.users-container');
//     var skillsList= [];
    $(".search-members-input").keyup(checkInput);
    $(".filter").change(checkInput);
    
    $('.search-button').addClass("opacity-50 pointer-events-none");
    
    function checkInput(){
	    var searchString = $('.search-members-input').val();
	   var $skills = $('.member-skill-slider:checkbox:checked');
	   var skillsList = [];
      for (var i = 0; i < $skills.length; i++) {
        skillsList.push($($skills[i]).data('skill'));
      }
// 	   console.log(skillsList);
		if (searchString.length >= 3 || skillsList.length>=1) {  
	      $('.search-button').removeClass("opacity-50 pointer-events-none");
	    }else{
		    $('.search-button').addClass("opacity-50 pointer-events-none");
		}
    }
    
    function search () {
      var searchString = $('.search-members-input').val();
      
      var $skills = $('.member-skill-slider:checkbox:checked');
      var skillsList = [];
      for (var i = 0; i < $skills.length; i++) {
        skillsList.push($($skills[i]).data('skill'));
      }
      
      if (searchString.length < 3 && skillsList.length==0) {
        return;
      }
      
      $userContainer.html('');
      $spinner.show();
      $.ajax({
        method: 'POST',
        url: window.my_ajax_object.ajax_url,
        dataType: "json",
        data: {
          action: 'search_members',
          searchString: searchString,
          skills: skillsList.length > 0 ? skillsList.join(",") : 0
        }, success: function (response) {
          $spinner.hide();
          $userContainer.html(response.data);
          setTimeout(function () {
            $('html, body').animate({
              scrollTop: $userContainer.offset().top - 150
            }, 1000);
          }, 0)
        }, error: function (error) {
          console.log("error", error);
        }
      });
    }

    $('body').on('click', '.company-name', function () {
      var company = $(this).data('company');
      $userContainer.html('');
      $spinner.show();
      $.ajax({
        method: 'POST',
        url: window.my_ajax_object.ajax_url,
        dataType: "json",
        data: {
          action: 'search_members',
          searchString: company,
        }, success: function (response) {
          $spinner.hide();
          $userContainer.html(response.data);
          setTimeout(function () {
            $('html, body').animate({
              scrollTop: $('.users-container').offset().top - 150
            }, 1000);
          }, 0)
        }, error: function (error) {
          console.log("error", error);
        }
      });
    });

    $('.search-members-form').on('submit', function (e) {
      e.preventDefault();
      search();
    });
    // New Release 2
    $('.search-members-input').on("update"), function(e){
	  e.preventDefault();
	  
	  var $skills = $('.member-skill-slider:checkbox:checked');
      var skillsList = [];
      for (var i = 0; i < $skills.length; i++) {
        skillsList.push($($skills[i]).data('skill'));
      }
	  
	    var searchString = $('.search-members-input').val();
	    if (searchString.length >= 3) {
		    $('.search-button').removeClass("opacity-50 pointer-events-none");
	    }else if(searchString.length < 3 && skillsList.length==0){
		    $('.search-button').addClass("opacity-50 pointer-events-none");
	    }
    }
	// end new
	
    $('.toggle-filter').on('click', function () {
      $('.filter').toggleClass('hidden').toggleClass('flex');
      $('.filter-hidden').toggle();
    });
    $('.search-button').on('click', function () {
      search();
    });
    var params = new URLSearchParams(new URL(window.location.href).search);
    if (params.has('searchstring')) {
      var company = params.get('searchstring');
      $.ajax({
        method: 'POST',
        url: window.my_ajax_object.ajax_url,
        dataType: "json",
        data: {
          action: 'search_members',
          searchString: company,
        }, success: function (response) {
          $userContainer.html(response.data);
          setTimeout(function () {
            $('html, body').animate({
              scrollTop: $userContainer.offset().top - 150
            }, 1000);
          }, 0)
        }, error: function (error) {
          console.log("error", error);
        }
      });
    }
  }
};
